import * as React from "react";
import { Check, Heading2 } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { motion } from "framer-motion";


const FeatureCard = ({ index, title, description, icon, benefits }) => {
  return(
    <div className="mb-8">
      <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          viewport={{ once: true }}
        >
        <Card className="h-full border-none shadow-lg hover:shadow-xl transition-shadow bg-white">
          <CardContent className="p-6 flex flex-col h-full">
            <div className="text-4xl mb-4 flex items-center">
              <span role="img" aria-label={title}>{icon}</span>
              <h3 className="text-xl font-bold ml-2">{title}</h3>
            </div>
            <p className="text-gray-600 flex-grow">{description}</p>
            <ul className="mt-4 space-y-2">
              {benefits.map((benefit, i) => (
                <li key={i} className="flex items-start">
                  <Check className="h-5 w-5 text-primary-500 mr-2 shrink-0 mt-0.5" />
                  <span className="text-sm">{benefit}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}

const FeatureSection = ({ title, description, features }) => {
  return(
    <div className="lg:m-8">
      <div className="text-center mb-8">
        <h2 className="text-2xl mb-2">{title}</h2>
        <p className="text-gray-600">{description}</p>
      </div>
      <div className="">
        {features.map((feature, index) => (
          <FeatureCard key={index} index={index} {...feature} />
        ))}
      </div>
    </div>
  )
}

const TherapistValueProps = () => {

  const lead_generation_features = {
    title:"Lead Generation",
    description: "Get more qualified leads and grow your practice.",
    features:[
      {
        title: "Serve Diverse Communities",
        description: "Connect with patients who need your cultural knowledge and language skills.",
        icon: "🌍",
        benefits: [
          "Client cultural matching",
          "Community outreach tools"
        ]
      },
      {
        title: "Get More Appointments",
        description: "Receive qualified leads from our platform to grow your existing practice.",
        icon: "📞",
        benefits: [
          "Qualified lead generation",
          "Get featured in our directory"
        ]
      }
    ]
  };

  const management_features = {
    title: "Practice Management",
    description: "Complete practice management tools to streamline your workflow.",
    features:[
      {
        title: "Complete Management Suite",
        description: "Use our built-in tools for scheduling, video sessions, and payment processing.",
        icon: "📅",
        benefits: [
          "Integrated EHR system",
          "Automated billing"
        ]
      },
      {
        title: "Grow Your Impact",
        description: "Host virtual classes and events to expand your reach and practice.",
        icon: "📈",
        benefits: [
          "Marketing resources",
          "Passive income streams"
        ]
      }
    ]
  };

  return (
    <section className="py-16 bg-background/30">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 text-primary">For Therapists</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Join our platform to grow your practice while making an impact on underserved communities.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 mb-12">
          <div className="border-b-2 lg:border-b-0 lg:border-r-2 border-primary/50">
            <FeatureSection {...lead_generation_features} />
            <div className="mt-12 mb-4 text-center">
              <h2 className="text-lg font-bold mb-2" >Get listed for free</h2>
              <a href="/therapists/sign_up">
                <Button className="rounded-full text-white px-8 py-6 h-auto text-lg">
                  Join Now
                </Button>
              </a>
            </div>
          </div>
          <div className="mt-8 lg:mt-0">
            <FeatureSection {...management_features} />
            <div className="mt-12 text-center">
              <h2 className="text-lg font-bold mb-2">Upgrade to full practice management</h2>
              <a href="https://calendly.com/safdarzeeshan/mindpulse-therapy" >
                <Button variant="outline" className="border-primary/90 hover:bg-primary text-primary hover:text-white rounded-full px-8 py-6 h-auto text-lg">
                  Contact Sales For Pricing
                </Button>
              </a>
            </div>
          </div>
          
        </div>


      </div>
    </section>
  );
};

export default TherapistValueProps;
